import BannersSection from "./BannersSection";
import ProductsSection from "./ProductsSection";
import BrandsSection from "./BrandsSection";
import CouponsSection from "./CouponsSection";

const componentMap = {
  BANNERS: BannersSection,
  PRODUCTS: ProductsSection,
  BRANDS: BrandsSection,
  COUPONS: CouponsSection,
};

export default function SectionComponent(props) {
  const { section } = props;
  const Component = componentMap[section.type];

  if (!Component) return null;

  return <Component {...props} />;
}
